<template>
  <div class="mb-4">
    <img
      :src="block.form.image.url"
      @click="$parent.$refs.imageLightbox.open(block.form.image.id)"
      alt
      class="cursor-pointer"
    />
    <div
      v-if="block.form.caption"
      class="text-center text-gray-600 mt-2 text-sm"
    >{{ block.form.caption }}</div>
  </div>
</template>

<script>
export default {
  props: {
    block: {}
  },
  created() {
    // Add all images to the lightbox list
    // this.$nextTick(() => {
    //   this.$parent.$refs.imageLightbox.images.push({
    //     id: this.block.form.image.id,
    //     url: this.block.form.image.url,
    //     caption: this.block.form.caption
    //   })
    // })
  }
}
</script>

<style lang="scss" scoped></style>
